function adjustHeader() {
  const $header = $("#header");
  const trigger = $(".hero").outerHeight() * 0.4;
  const scrollTop = $(window).scrollTop();

  if (window.location.pathname === '/') {
    if (scrollTop < trigger) {
      $header.addClass("header--expanded");
    } else {
      $header.removeClass("header--expanded");
    }
  }
}

$(window).on("scroll", adjustHeader);
$(document).ready(adjustHeader);
